var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "s-modal",
    {
      attrs: {
        title: _vm._f("capitalize")(
          _vm._f("translate")(!_vm.is_edit ? "create_profile" : "edit_profile")
        ),
        id: "profile-modal"
      }
    },
    [
      _c("s-base-form", {
        attrs: {
          slot: "body",
          pModel: _vm.model,
          isProfile: true,
          isEdit: _vm.is_edit
        },
        slot: "body"
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-237b293a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-237b293a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/admin/profiles/New.vue
// module id = 497
// module chunks = 0 1 133 134